<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#5E646A"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.87415 14.351V16.44H9.96084L14.9289 11.467L12.8415 9.37723L7.87415 14.351Z" fill="white"/>
    <mask id="mask0_25_4986" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="13" y="7" width="4" height="4">
    <path d="M13.5579 7.39966H16.9043V10.7499H13.5579V7.39966Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_25_4986)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6893 8.65353L15.6518 7.61491C15.365 7.32771 14.9005 7.32771 14.6144 7.61491L13.5579 8.67263L15.6328 10.7499L16.6893 9.69216C16.9762 9.40496 16.9762 8.94 16.6893 8.65353Z" fill="white"/>
    </g>
</svg>
